<template>
    <div class="row">
        <div class="col-md-7">
            <div class="p-4 rounded-lg shadow-sm bg-white mb-3">
                <Alerts :_success="success" :_error="error"></Alerts>

                <form @submit.prevent="applyLoan()">
                    <div class="form-group row">
                        <div class="offset-4 col-md-8">
                            <h5 class="font-weight-bold">Loan Application</h5>
                            <span class="text-muted">Loan Application Form</span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="product_id" class="col-md-4 col-form-label text-md-right">Loan Product</label>
                        <div class="col-md-7">
                            <select id="product_id" v-model="loan.product_id" class="form-control"
                                    :disabled="wait"
                                    @change="setProduct($event); getRepayments()" required>
                                <option v-for="i in products" :value="i.id" :key="i.id">{{ i.name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="rate" class="col-md-4 col-form-label text-md-right">Rate (Monthly)</label>
                        <div class="col-md-7">
                            <input id="rate" :value="loan.rate + `%`" class="form-control" disabled/>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="period" class="col-md-4 col-form-label text-md-right">Loan Period</label>
                        <div class="col-md-7">
                            <select id="period" v-model="loan.period" class="form-control mb-2"
                                    @change="getRepayments()"
                                    :disabled="wait" required>
                                <option value="">--select--</option>
                                <option v-for="i in periodLength" :value="i" :key="i">
                                    {{ i }} Months
                                </option>
                            </select>
                            <span class="text-muted">Period between {{ product.min_period }} & {{ product.max_period }} months</span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="amount" class="col-md-4 col-form-label text-md-right">Loan Amount ({{
                                loan.currency
                            }})</label>
                        <div class="col-md-7">
                            <input id="amount" v-model="loan.amount" class="form-control mb-2"
                                   :min="product.min_amount"
                                   :max="product.max_amount" step="100" :disabled="wait"
                                   placeholder="Enter loan amount" @change="getRepayments()"
                                   required>
                            <span class="text-muted">Amount between {{ product.min_amount }} & {{
                                    product.max_amount
                                }}</span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="amount" class="col-md-4 col-form-label text-md-right">Currency</label>
                        <div class="col-md-7">
                            <select class="form-control" v-model="loan.currency" :disabled="wait" required>
                                <option>USD</option>
                                <option>KES</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="purpose" class="col-md-4 col-form-label text-md-right">Loan Purpose</label>
                        <div class="col-md-7">
                                <textarea id="purpose" v-model="loan.purpose" rows="2" required
                                          placeholder="Loan purpose/use" :disabled="wait"
                                          class="form-control mb-2"></textarea>
                            <span class="text-muted">Explain why you need the loan</span>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="offset-4 col-md-7">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="terms" v-model="terms">
                                <label class="custom-control-label" for="terms">
                                    I Agree to our<a href="#">Terms & Conditions</a>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="offset-4 col-md-7">
                            <button class="btn btn-dark btn-block"
                                    :disabled="wait || !loan.product_id || !loan.amount || !terms">Submit Application
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </div>

        <div class="col-md-5">
            <div class="p-4 bg-white shadow-sm rounded-lg mb-3">
                <h5 class="font-weight-bold">Calculations</h5>
                <p class="text-muted">Loan Repayment computations</p>

                <table class="table table-bordered mb-4 table-sm">
                    <tr>
                        <th class="bg-light">Disbursement</th>
                        <td>USD {{ disbursement }}</td>
                    </tr>
                    <tr>
                        <th class="bg-light">Interest</th>
                        <td>USD {{ interest }} ({{ loan.rate }}%)</td>
                    </tr>
                    <tr>
                        <th class="bg-light">Repayment</th>
                        <td>USD {{ repayment }}</td>
                    </tr>
                </table>
            </div>

            <div class="p-4 bg-white shadow-sm rounded-lg">
                <h5 class="font-weight-bold">Repayments</h5>
                <p class="text-muted">Repayment Dates</p>

                <table class="table table-sm table-borderless">
                    <thead class="bg-light">
                    <tr>
                        <th>SN</th>
                        <th>REPAYMENT DATE</th>
                        <th class="text-right">AMOUNT</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="repayments.length == 0">
                        <td colspan="3" class="text-danger">Select product, period & loan amount</td>
                    </tr>
                    <tr v-else v-for="i in repayments" :key="i.sn">
                        <td class="text-muted">{{ i.sn }}</td>
                        <td>{{ i.date }}</td>
                        <td class="text-right">{{ i.amount }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Alerts from "@/components/Alerts";

export default {
    name: "Loan",
    components: {Alerts},
    data() {
        return {
            products: [],
            product: {
                rate: 0,
                min_period: 0,
                max_period: 0,
                min_amount: 0,
                max_amount: 0
            },

            fees: 0,
            terms: false,
            repayments: [],

            loan: {
                product_id: '',
                period: '',
                currency: 'USD',
                rate: 0,
                amount: '',
                purpose: ''
            }
        }
    },
    mounted() {
        this.loadProducts()
    },
    computed: {
        periodLength() {
            let min = 1
            let max = 1
            if (this.product) {
                min = parseInt(this.product.min_period)
                max = parseInt(this.product.max_period)
            }
            let arr = [];
            for (var i = min; i <= max; i++) {
                arr.push(i)
            }
            return arr
        },
        interest() {
            let interest = ((this.loan.rate / 100) * this.loan.amount).toFixed();
            let value = parseFloat(interest * parseInt(this.loan.period));
            return isNaN(value) ? 0 : value;
        },
        disbursement() {
            let value = (parseFloat(this.loan.amount) - this.fees);
            return isNaN(value) ? 0 : value;
        },
        repayment: function () {
            let value = (parseFloat(this.loan.amount) + this.interest);
            return isNaN(value) ? 0 : value;
        },
    },
    methods: {
        applyLoan() {
            window.scroll(0, 0)
            this.wait = true
            this.clear()
            this.success = "Sending loan application, please wait"
            this.$http.post('/loans/apply', this.loan).then(() => {
                this.success = "Loan application sent successfully, redirecting to loan details..."
                setTimeout(() => (this.$router.push('/loans')), 600)
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.wait = false
            })
        },
        loadProducts() {
            this.wait = true
            this.clear()
            this.success = "Loading loan products..."
            this.$http.get('/loans/products').then(res => {
                this.products = res.data.data
                this.success = ''
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.wait = false
            })
        },
        setProduct(event) {
            let id = event.target.value;
            if (id) {
                this.product = this.products.find(a => a.id == id)
                this.loan.rate = this.product.rate
            }
        },
        getRepayments() {
            if (this.loan.amount && this.loan.period) {
                window.scroll(0, 0)
                this.wait = true
                this.clear()
                this.success = 'Computing loan repayments...'
                this.$http.get(`/loans/repayments/${this.repayment}/${this.loan.period}`).then(response => {
                    this.repayments = response.data.data
                    this.success = ''
                }).catch(error => {
                    this.showError(error)
                }).then(() => {
                    this.wait = false
                })
            }
        }
    }
}
</script>

<style scoped>

</style>